import styled from 'styled-components'

export const StyledContent = styled.section`
  display: flex;
  justify-content: center;
  margin-top: 50px;
  padding: 0 20px;
`
